import axios from "axios";
import { base_api_url, base_api_audit_url } from "../config";

// test
const api1 = base_api_audit_url;
const token = localStorage.getItem("token") || "";

// Get Audits
export const getAudits = async () => {
  const { data: audits } = await axios.get(api1, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return audits;
};

const api = base_api_url;

export const getMethodPagination = async (route, page) => {
  const { data: collection } = await axios.get(api + route, {
    headers: { Authorization: `Bearer ${token}` },
    params: {
      page: page,
    },
  });
  return collection;
};
export const getMethodPaginationWithFilter = async (route, page, filter) => {
  // console.log("route, page, filter", route, page, filter)
  const { data: collection } = await axios.get(api + route, {
    headers: { Authorization: `Bearer ${token}` },
    params: {
      page: page,
      status: filter,
    },
  });
  return collection;
};

export const getMethod = async (route) => {
  const { data: collection } = await axios.get(api + route, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return collection;
};

export const getMethodSearch = async (
  route,
  searchQuery,
  searchType,
  statusType,
  dateType
) => {
  const { data: collection } = await axios.get(api + route + searchQuery, {
    headers: { Authorization: `Bearer ${token}` },
    params: {
      searchBy: searchType,
      status: statusType,
      dateBy: dateType,
    },
  });
  return collection;
};

export const putMethod = async (route, id, content) => {
  const response = await axios.put(api + route + id, content, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response;
};
export const putMethodSettings = async (route, content) => {
  const response = await axios.put(api + route, content, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response;
};

export const putMethodFormData = async (route, id, content) => {
  const response = await axios.put(api + route + id, content, {
    headers: {
      Authorization: `Bearer ${token}`,
      "content-type": "application/json",
    },
  });
  return response;
};

export const postMethod = async (route, content) => {
  const response = await axios.post(api + route, content, {
    headers: {
      Authorization: `Bearer ${token}`,
      "content-type": "multipart/form-data",
    },
  });
  return response;
};
export const postMethodPermission = async (route, id) => {
  const response = await axios.post(api + route + id, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response;
};
export const postMethodNormal = async (route, content) => {
  const response = await axios.post(api + route, content, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response;
};
export const deleteMethod = async (route, id) => {
  const response = await axios.put(api + route + id, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response;
};



// WEBPACK FOOTER //
// ./src/services/httpServices.js